import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useIsMobile } from "../lib/useIsMobile";

/**
 * MobileRootRedirect
 * ----------------------------------------------------------------
 * On the root path (`/`), auto-forward mobile visitors to `/app`
 * so they land straight in the immersive EVIQ mobile experience
 * instead of the desktop marketing site.
 *
 * Escape hatches (all bypass the redirect):
 *   • URL query `?desktop=1`  — one-off "show me the full site" toggle
 *   • localStorage `eviq_view_pref = "desktop"` — sticky preference
 *     (set by the "View full site" link inside /app)
 */
export const MobileRootRedirect = ({ children }) => {
  const isMobile = useIsMobile();
  const { search } = useLocation();

  const wantsDesktop =
    new URLSearchParams(search).get("desktop") === "1" ||
    (typeof window !== "undefined" &&
      window.localStorage?.getItem("eviq_view_pref") === "desktop");

  if (isMobile && !wantsDesktop) {
    // Preserve query params (?tesla=connected&session_id=… etc.) when
    // forwarding — otherwise post-OAuth redirects lose their session state
    // and the Tesla welcome/sync flow never fires.
    return <Navigate to={`/app${search || ""}`} replace />;
  }
  return children;
};
